<div class="unsubscribe-wrapper v2">
  <div class="unsubscribe-grid-container">
    <div class="unsubscribe-content-area">
      <div class="content-box">
        <div class="box-item">
          @if (showLoader) {
            <ev-logo-loader width="70px" />
          } @else {
            @if (unsubscribeState === IUnsubscribeState.none) {
              <div class="unsubscribe-icon default"></div>
            } @else if (unsubscribeState === IUnsubscribeState.success) {
              <div class="unsubscribe-icon success"></div>
            } @else {
              <div class="unsubscribe-icon fail"></div>
            }
          }
        </div>
        <div class="box-item pad">
          <div class="unsubscribe-text" [innerText]="deleteMessage"></div>
        </div>
        @if (unsubscribeState === IUnsubscribeState.none) {
          <div class="box-item">
            <div class="btn">
              <div class="unsubscribe-button" (click)="unsubscribe()">Avslutt</div>
            </div>
          </div>
        } @else {
          <div class="box-item">
            @if (unsubscribeState === IUnsubscribeState.success) {
              Du kan trygt lukke dette vinduet eller gå til
              <a href="https://www.eiendomsverdi.no">&nbsp;eiendomsverdi.no</a>
            } @else if (unsubscribeState === IUnsubscribeState.fail) {
              For support, kontakt
              <a
                [href]="'mailto:' + support.email">&nbsp;{{ support.email }}</a>&nbsp;eller ring {{ support.phone }}
            }
          </div>
        }
      </div>
    </div>
    <div class="unsubscribe-footer-area">
      <div class="footer-box">
        <div class="footer-box__logo"></div>
        <div class="footer-box__copyright">©2000-2024 Eiendomsverdi AS</div>
      </div>
    </div>
  </div>
</div>
